<template>
    <div class="wrapper" :class="{disabled}">
        <!-- Single selection current -->
        <div ref="current-container" class="current-container" @click="open">
            <span class="text" v-if="value">{{labelToDisplay}}</span>
            <span v-else>{{placeholderToDisplay}}</span>
            <span class="down-arrow"></span>
        </div>

        <!-- Single selection options -->
        <div v-if="isOpened" ref="option-container" class="option-container" v-on-clickaway="close"
            :style="optionsContainerPosition"
        >
            <div v-for="option in options" :data-value="option[valueAttribute]" class="option" @click="setSelectedOption(option)">
                <span v-if="noOptionSlot" class="text" :class="{checked: (value && isSelected(value, option))}" >{{option[labelAttribute]}}</span>
                <slot v-else name="option" :class="{checked: (value && isSelected(value, option))}" :option="option"></slot>
            </div>
        </div>
    </div>
</template>

<script>
import {directive as onClickaway} from 'vue-clickaway';

export default {
    directives: {
        onClickaway: onClickaway,
    },
    props: {
        options: {
            type: Array,
            required: true
        },
        placeholder: {
            type: String
        },
        value: {
            required: true
        },
        valueAttribute: {
            type: String,
            require: true
        },
        labelAttribute: {
            type: String,
            require: true
        },
        allowMultipleSelection: {
            type: Boolean,
            default: false
        },
        preselectFirst: {
            type: Boolean,
            default: true
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        labelToDisplay() {
            if (this.value)  {
                const option = this.options.find((o) => o[this.valueAttribute] === this.value);
                if (option) {
                    return option[this.labelAttribute];
                }
            }
            return '';
        },
        noOptionSlot() {
            return !this.$scopedSlots.option;
        },
        placeholderToDisplay() {
            return this.placeholder || this.$t('general.please_select');
        }
    },
    data() {
        return {
            isOpened: false,
            optionsContainerPosition: null,
            optionContainerEl: null
        }
    },
    mounted() {
        if (this.preselectFirst) {
            if (this.options.length > 0 && (!this.value)) {
                this.setSelectedOption(this.options[0]);
            }
        }
        window.addEventListener('scroll', this.positionOptionsContainer, true);
    },
    beforeDestroy() {
        this.close();
    },
    destroyed() {
        window.removeEventListener('scroll', this.positionOptionsContainer, true);
    },
    methods: {
        setSelectedOption(option) {
            this.isOpened = false;
            this.$emit('input', option[this.valueAttribute]);
            this.$nextTick(() => this.positionOptionsContainer())
        },
        open() {
            if (this.disabled) {
                this.isOpened = false;
                return;
            } 
            this.isOpened = true;
            this.positionOptionsContainer();
            this.$nextTick(() => {
                this.optionContainerEl = this.$refs['option-container'];
                if (this.optionContainerEl.parentElement && this.optionContainerEl.parentElement.tagName !== 'BODY') {
                    this.optionContainerEl.parentElement.removeChild(this.optionContainerEl);
                }
                $('body').append(this.optionContainerEl);
                this.positionOptionsContainer();
            });
        },
        positionOptionsContainer() {
            if (!this.$refs['current-container']) {
                return
            }
            var contentHeight = 160;
            if (this.$refs['option-container']) {
                contentHeight = $(this.$refs['option-container']).height();
            }
            var bodyWidth = $('body').get(0).getBoundingClientRect().width;
            var totalHeight = $(window).innerHeight();
            var currentContainerOffset = this.$refs['current-container'].getBoundingClientRect();
            var $currentContainer = $(this.$refs['current-container']);

            var minWidth = $currentContainer.outerWidth();
            if (currentContainerOffset.left + minWidth + 24 < $(window).width()) {
                minWidth += 24;
            }

            // show on bottom
            const maxHeight = totalHeight - 8/*padding*/ - currentContainerOffset.bottom;
            this.optionsContainerPosition = {
                top: (currentContainerOffset.top + $currentContainer.outerHeight() + 2) + 'px',
                left: currentContainerOffset.left + 'px',
                minWidth: minWidth + 'px',
                maxWidth: (bodyWidth - currentContainerOffset.left - 16) + 'px',
                maxHeight: maxHeight + 'px'
            };
        },
        clearSelection() {
            this.value = null;
            this.$emit('input', null);
        },
        close() {
            if (this.optionContainerEl && this.optionContainerEl.parentElement) {
                this.optionContainerEl.parentElement.removeChild(this.optionContainerEl);
            }
            this.isOpened = false;
        },
        isSelected(value, option) {
            return value[this.valueAttribute] == option[this.valueAttribute];
        }
    }
}
</script>

<style lang="scss" scoped>
::-webkit-scrollbar {
    -webkit-appearance: none;
    width: 6px;
}
::-webkit-scrollbar-thumb {
    border-radius: 4px;
    background-color: rgba(0, 0, 0, .5);
    -webkit-box-shadow: 0 0 1px rgba(255, 255, 255, .5);
}
.wrapper {
    position: relative;
}
.current-container {
    padding: 0.375rem 1.2rem;
    padding-right: 32px;
    background: #F4F8F9;
    border-radius: 4px;
    display: inline-block;
    font-size: 1rem;
    color: #31393C;
    user-select: none;
    width: 100%;
    position: relative;

    &:hover {
        background-color: #F2F6F7;
        cursor: pointer;
    }

    .down-arrow {
        display: block;
        width: 10px;
        height: 10px;
        background-image: url('/img/listdown@2x.png');
        background-size: contain;
        background-position: center 3px ;
        background-repeat: no-repeat;
        font-size: 8px !important;
        margin: 0 4px 0 8px;
        position: absolute;
        right: 6px;
        top: 10px;
    }
}

.option-container {
    box-shadow: 0px 1px 10px 2px rgba(0, 0, 0, 0.36);
    background: white;
    font-size: 1rem;
    z-index: 2147483647;
    border-radius: 3px;
    overflow: auto;

    position: fixed;
}

    .option {
        cursor: pointer;
        padding: 4px 12px;
        text-align: center;
        &:hover {
            background: #F4F8F9;
        }
    }

.wrapper.disabled .current-container {
    color: #8E9FA7 !important;
    cursor: not-allowed;
}
</style>
